var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterTypeText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M2.625 6.563a.437.437 0 0 0 .438-.438V2.188h4.812v2.625a.437.437 0 0 0 .438.437h2.624v.875a.438.438 0 0 0 .876 0V4.813a.44.44 0 0 0-.129-.31L8.623 1.44a.44.44 0 0 0-.31-.127h-5.25a.875.875 0 0 0-.874.875v3.937a.437.437 0 0 0 .437.438M8.75 2.806l1.569 1.569H8.75zm-.3 5.76-.912 1.278.912 1.277a.438.438 0 0 1-.711.508L7 10.596l-.738 1.033a.438.438 0 1 1-.71-.508l.91-1.277-.912-1.277a.438.438 0 1 1 .711-.509L7 9.091l.738-1.033a.438.438 0 0 1 .71.509zM5.03 8.313a.437.437 0 0 1-.437.438h-.657v2.625a.438.438 0 0 1-.874 0V8.75h-.657a.437.437 0 1 1 0-.875h2.188a.437.437 0 0 1 .437.438m7 0a.437.437 0 0 1-.437.438h-.656v2.625a.438.438 0 0 1-.876 0V8.75h-.656a.437.437 0 1 1 0-.875h2.188a.437.437 0 0 1 .437.438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTypeText);
export default __webpack_public_path__ + "static/media/filter-type-text.ed56e0bbcd8c366969e29a39583f0d5b.svg";
export { ForwardRef as ReactComponent };